import React, { useState, useEffect } from "react";
import { Toast } from "../../Components";
import { Profile } from "../../Components";

import { flushService } from "../../Services"

export default function FlushCache({ setAuth, setModal, NotifModul, account, profiles, setModalNotification, locationData }) {

  const [isloaded, setIsLoaded] = React.useState(false);
  const [toastList, setToastList] = useState([]);
  const [activityData, setActivityData] = useState([]);
  const addToast = (data) => {
    const newToastList = [...toastList];
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };

  const flushCategory = async (flushtype) => {
    try {
      const res = await flushService.flushCategory();

      if (res.success == true) {
        console.log(res)
        addToast({ error: false, date: new Date(), msg: res.message });
      }
    } catch (err) {

      addToast({ error: false, date: new Date(), msg: err });
    }
  }
  const flushPlan = async (flushtype) => {
    try {
      const res = await flushService.flushPlan();
      if (res.success == true) {
        addToast({ error: false, date: new Date(), msg: res.message });
      }
    } catch (err) {
      addToast({ error: false, date: new Date(), msg: err });
    }
  }
  const flushSearchInf = async () => {
    try {
      const res = await flushService.flushSearchInf();
      if (res.success == true) {
        addToast({ error: false, date: new Date(), msg: res.message });
      }
    } catch (err) {
      addToast({ error: false, date: new Date(), msg: err });
    }
  }
  const flushUserData = async () => {
    try {
      const res = await flushService.flushUserData();
      if (res.success == true) {
        addToast({ error: false, date: new Date(), msg: res.message });
      }
    } catch (err) {
      addToast({ error: false, date: new Date(), msg: err });
    }
  }

  return (
    <>

      <div className="main">
        <div className="main__inner">
          <div className="admnotif !mt-2">
            <div className="admnotif__table">
              <table>
                <thead>
                  <tr>
                    <th>Flush</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr >
                    <td>
                      <div onClick={flushCategory}>Flush Cache for Categories</div>
                    </td><td></td>
                  </tr>
                  <tr >
                    <td>
                      <div onClick={flushPlan}>Flush Cache for Plan</div>
                    </td><td></td>
                  </tr>
                  <tr >
                    <td>
                      <div onClick={flushSearchInf}>Flush Cache for Search Page</div>
                    </td><td></td>
                  </tr>
                  <tr >
                    <td>
                      <div onClick={flushUserData}>Flush Cache for User data Profile Page</div>
                    </td><td></td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {toastList && (
        <Toast type="rate" list={toastList} setList={setToastList} />
      )}
    </>
  );
}
